var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import * as classnames from "classnames";
import List from "../List";
import MenuGroup from "./MenuGroup";
import keyPressed from "../../utils/a11y";
var renderListItems = function (children, groupIndex) {
    if (groupIndex === void 0) { groupIndex = 0; }
    return React.Children.map(children, function (child) {
        return React.cloneElement(child, { groupIndex: groupIndex });
    });
};
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu(props) {
        var _this = _super.call(this, props) || this;
        _this.getOuterClassNames = function () {
            var _a = _this.props, noMaxHeight = _a.noMaxHeight, stretched = _a.stretched;
            /**
             * If any of the menu items is navigable, the menu should lose
             * its max height.
             */
            React.Children.forEach(_this.props.children, function (element) {
                if (element && element.props && element.props.isNavigable) {
                    noMaxHeight = true;
                }
            });
            return classnames("wds-has-menu", "wds-has-menu--show", { "wds-has-menu--stretched": stretched }, { "wds-menu--no-max-height": noMaxHeight });
        };
        _this.getMenuClassNames = function () {
            var _a;
            var direction = _this.props.direction;
            return classnames("wds-menu", (_a = {}, _a["wds-menu--" + direction] = !!direction, _a));
        };
        _this.handleAutoCloseClick = function (e) {
            if (_this.menu && !_this.menu.contains(e.target)) {
                _this.menuChange(false);
            }
        };
        _this.handleAutoCloseBlur = function () {
            setTimeout(function () {
                if (_this.menu && !_this.menu.contains(document.activeElement)) {
                    _this.menuChange(false);
                }
            }, 0);
        };
        _this.handleClick = function () {
            var show = _this.state.show;
            _this.menuChange(!show);
        };
        _this.renderTrigger = function () {
            var menuTrigger = _this.props.menuTrigger;
            return React.cloneElement(menuTrigger, {
                "aria-haspopup": true,
                //TODO this doesn't work
                // "aria-owns": show ? this.id : null,
                onClick: _this.handleClick,
                onKeyPress: keyPressed("Enter", _this.handleClick)
            });
        };
        _this.renderList = function () {
            // TODO make sure only MenuItem or MenuGroup are passed in
            var items = React.Children.map(_this.props.children, function (child, index) {
                if (child.type && child.type.displayName === "MenuGroup") {
                    return (React.createElement(MenuGroup, null,
                        React.createElement(List, __assign({ interactive: true, noRules: true, dense: _this.props.dense }, _this.props), renderListItems(child.props.children, index))));
                }
                return null;
            });
            if (items.length)
                return items;
            return (React.createElement(List, __assign({ noRules: true, interactive: true, dense: _this.props.dense }, _this.props), renderListItems(_this.props.children)));
        };
        _this.renderMenu = function () { return (React.createElement("div", { className: _this.getMenuClassNames(), role: "menu" },
            React.createElement("div", { className: "wds-menu__body" }, _this.renderList()))); };
        _this.state = { show: props.show };
        return _this;
    }
    Menu.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.show !== this.state.show) {
            this.setState({ show: nextProps.show });
        }
    };
    Menu.prototype.componentDidUpdate = function () {
        var autoClose = this.props.autoClose;
        var show = this.state.show;
        if (autoClose) {
            if (show) {
                document.addEventListener("click", this.handleAutoCloseClick);
            }
            else {
                document.removeEventListener("click", this.handleAutoCloseClick);
            }
        }
    };
    Menu.prototype.menuChange = function (show) {
        this.setState({ show: show });
        if (this.props.onChange) {
            this.props.onChange({ show: show });
        }
    };
    Menu.prototype.render = function () {
        var _this = this;
        return (React.createElement("span", { className: this.getOuterClassNames(), onBlur: this.handleAutoCloseBlur, ref: function (menu) {
                _this.menu = menu;
            } },
            this.renderTrigger(),
            this.state.show && this.renderMenu()));
    };
    Menu.defaultProps = {
        autoClose: false,
        dense: false,
        direction: null,
        noMaxHeight: false,
        onChange: null,
        stretched: false,
        show: false
    };
    return Menu;
}(React.Component));
export default Menu;
//# sourceMappingURL=Menu.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/components/Menu/Menu.js
// module id = 1789
// module chunks = 17